import { EditTwoTone, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, FormInstance, InputNumber, Row, Select } from "antd";
import React from "react";
import { PayrollYearlySettingsUpdateTypes } from "../../Services/PayrollYearlySettingsService";
import { Utils } from "../../Utilities/Utils";

interface iAllowanceLimitsAndLoansProps {
  isViewOnly: boolean;
  form: FormInstance<any>;
  isEdit: {
    type: PayrollYearlySettingsUpdateTypes;
  };
  setIsEdit: React.Dispatch<
    React.SetStateAction<{
      type: PayrollYearlySettingsUpdateTypes;
    }>
  >;
  OnSaveClick: () => Promise<void>;
  OnCancelClick: () => void;
}

const AllowanceLimitsAndLoans = ({
  isViewOnly = false,
  form,
  isEdit,
  setIsEdit,
  OnSaveClick,
  OnCancelClick,
}: iAllowanceLimitsAndLoansProps) => {
  return (
    <React.Fragment>
      <Form disabled={isViewOnly} form={form}>
        {/* Allowance Limits */}
        <Col className="card border pb-3 border-rounded-1 bg-secondary">
          <Row
            className="border-bottom  px-2 py-1 font-bold"
            justify="space-between"
          >
            Allowance Limits
            {
              !isViewOnly ?
                <span
                  className="edit-btn"
                  onClick={() =>
                    setIsEdit({
                      type: PayrollYearlySettingsUpdateTypes.allowanceLimits,
                    })
                  }
                >
                  <EditTwoTone />
                </span>
                : null
            }
          </Row>
          <Row className="px-3 py-1">
            {/* Average Weekly Earning (AWE) */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Average Weekly Earning (AWE)"
                name="awe"
                style={{ width: "100%" }}
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="Average Weekly Earning"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}                
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Waiting Days */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Waiting Days"
                name="waitingDays"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="Waiting Days"
                  className="line-height-28"
                  style={{ width: "100%" }}
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}                
                />
              </Form.Item>
            </Col>
            {/* Employment Allowance Limit */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Employment Allowance Limit"
                name="eaLimit"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="Employment Allowance Limit"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Employee's NI start limit as director */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Employee's NI start limit as director"
                name="eeDirAnnualLimit"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="Employee's NI start limit as director"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Employeer's NI start limit for director */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Employeer's NI start limit for director"
                name="erDirAnnualLimit"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="Employeer's NI start limit for director"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider
            className="px-3"
            orientation="left"
            orientationMargin="0"
            style={{ margin: "0px 0px 0px 0px" }}
          >
            <p style={{ fontSize: "15px", fontWeight: 600 }}>Pension Details</p>
          </Divider>

          <Row className="px-3 py-1">
            {/* SSP Weekly Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SSP Weekly Pay"
                name="sspWkPay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SSP Weekly Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* SAP AWE Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SAP AWE Pay"
                name="sapawePay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SAP AWE Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* SNC PAWE Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SNC PAWE Pay"
                name="sncpawePay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SNC PAWE Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* SMP AWE Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SMP AWE Pay"
                name="smpawePay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SMP AWE Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* PP Birth AWE Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="PP Birth AWE Pay"
                name="ppBirthAWEPay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="PP Birth AWE Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* PP Adoption AWE Pay */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="PP Adoption AWE Pay"
                name="ppAdoptionAWEPay"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="PP Adoption AWE Pay"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* SP Reclaim Rate SER */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SP Reclaim Rate SER"
                name="spReclaimRateSER"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SP Reclaim Rate SER"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* SP Reclaim Rate */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="SP Reclaim Rate"
                name="spReclaimRate"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.allowanceLimits
                      ? false
                      : true
                  }
                  placeholder="SP Reclaim Rate"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {(!isViewOnly && isEdit.type === PayrollYearlySettingsUpdateTypes.allowanceLimits) && (
            <Row className="px-3 pt-3">
              <Button type="primary" onClick={OnSaveClick}>
                <SaveOutlined /> Save
              </Button>
              <Button className="ms-2" onClick={OnCancelClick}>
                <CloseOutlined /> Cancel
              </Button>
            </Row>
          )}
        </Col>

        {/* Loans Thresholds */}
        <Col className="card mt-3 border pb-3 border-rounded-1 bg-secondary">
          <Row
            className="border-bottom  px-2 py-1 font-bold"
            justify="space-between"
          >
            Loans Thresholds
            <span
              className="edit-btn"
              onClick={() =>
                setIsEdit({
                  type: PayrollYearlySettingsUpdateTypes.loansThersholds,
                })
              }
            >
              {
                !isViewOnly ?
                  <EditTwoTone />
                  : null
              }
            </span>
          </Row>
          <Row className="px-3 py-1">
            {/* Loan Int Rate */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="loanIntRate"
                label="Loan Int Rate"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Loan Int Rate"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Student Loan Percentage */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPer"
                label="Student Loan Percentage"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Student Loan Percentage"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Postgraduate Loan Percentage */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="postgraduateLoanPer"
                label="Postgraduate Loan Percentage"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Postgraduate Loan Percentage"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Students Loan */}
          <Divider
            className="px-3"
            orientation="left"
            orientationMargin="0"
            style={{ margin: "5px 0px 0px 0px" }}
          >
            <p style={{ fontSize: "15px", fontWeight: 600 }}>Students Loan</p>
          </Divider>

          <Row className="px-3 py-1 font-semibold">
            <Col span={6}>Plan Type</Col>
            <Col span={6}>Weekly</Col>
            <Col span={6}>Monthly</Col>
            <Col span={6}>Annually</Col>
          </Row>
          {/* Plan1 */}
          <Row className="px-3 py-1">
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
              >
                <Select
                  disabled={true}
                  className="select-height-28"
                  value={1}
                  options={[
                    { value: 1, label: "Plan 1" },
                    // { value: 2, label: "Plan 2" },
                    // { value: 4, label: "Plan 4" },
                    // { value: 5, label: "Plan 5" },
                  ]}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan1Weekly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan1Weekly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Weekly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan1Monthly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan1Monthly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Monthly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan1Annual */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan1Annual"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Annually"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Plan2 */}
          <Row className="px-3 py-1">
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
              >
                <Select
                  disabled={true}
                  className="select-height-28"
                  value={2}
                  options={[
                    // { value: 1, label: "Plan 1" },
                    { value: 2, label: "Plan 2" },
                    // { value: 4, label: "Plan 4" },
                    // { value: 5, label: "Plan 5" },
                  ]}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan2Weekly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan2Weekly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Weekly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan2Monthly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan2Monthly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Monthly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan2Annual */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan2Annual"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Annually"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Plan4 */}
          <Row className="px-3 py-1">
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
              >
                <Select
                  disabled={true}
                  className="select-height-28"
                  value={4}
                  options={[
                    // { value: 1, label: "Plan 1" },
                    // { value: 2, label: "Plan 2" },
                    { value: 4, label: "Plan 4" },
                    // { value: 5, label: "Plan 5" },
                  ]}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan4Weekly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan4Weekly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Weekly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan4Monthly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan4Monthly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Monthly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan4Annual */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan4Annual"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Annually"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Plan5 */}
          <Row className="px-3 py-1">
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
              >
                <Select
                  disabled={true}
                  className="select-height-28"
                  value={5}
                  options={[
                    // { value: 1, label: "Plan 1" },
                    // { value: 2, label: "Plan 2" },
                    // { value: 4, label: "Plan 4" },
                    { value: 5, label: "Plan 5" },
                  ]}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan5Weekly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan5Weekly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Weekly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan5Monthly */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan5Monthly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Monthly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* stdLoanPlan5Annual */}
            <Col span={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="stdLoanPlan5Annual"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Annually"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Post graduation Loan */}
          <Row className="px-3 py-1">
            <Divider
              orientation="left"
              orientationMargin="0"
              style={{ margin: "0px 0px 0px 0px" }}
            >
              <p style={{ fontSize: "15px", fontWeight: 600 }}>Post graduation Loan</p>
            </Divider>

            {/* Loan Type */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Loan Type"
              >
                <Select
                  disabled={true}
                  className="select-height-28"
                  value={0}
                  options={[{ value: 0, label: "Post Graduation Loan" }]}
                />
              </Form.Item>
            </Col>
            {/* Weekly */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="postgraduateLoanWeekly"
                label="Weekly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Weekly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Monthly */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="postgraduateLoanMonthly"
                label="Monthly"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Monthly"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* Annually */}
            <Col xs={24} sm={12} lg={12} xl={8} xxl={6}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                name="postgraduateLoanAnnual"
                label="Annually"
              >
                <InputNumber
                  controls={false}
                  disabled={
                    isEdit.type ===
                      PayrollYearlySettingsUpdateTypes.loansThersholds
                      ? false
                      : true
                  }
                  placeholder="Annually"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          {(!isViewOnly && isEdit.type === PayrollYearlySettingsUpdateTypes.loansThersholds) && (
            <Row className="px-3 pt-3">
              <Button type="primary" onClick={OnSaveClick}>
                <SaveOutlined /> Save
              </Button>
              <Button className="ms-2" onClick={OnCancelClick}>
                <CloseOutlined /> Cancel
              </Button>
            </Row>
          )}
        </Col>
      </Form>
    </React.Fragment>
  );
};
export default AllowanceLimitsAndLoans;
